const MapLegend = ({ legends, onLegendChange }) => {
  const handleLegendClick = (legendId) => {
    onLegendChange(legendId);
  };

  return (
    <div
      className="map-legend-print"
      style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      flexWrap: 'nowrap',
      overflowX: 'auto', 
      paddingTop: '20px',
      paddingBottom: '20px',
      WebkitPrintColorAdjust: 'exact',
      printColorAdjust: 'exact',
    }}>
      {legends.map((legend, index) => (
        <div 
          key={index}
          onClick={() => handleLegendClick(legend.id)}
          style={{
            width: '100px',
            height: '100px', 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center', 
            margin: '0 5px', 
            backgroundColor: legend.show ? legend.color : '#444',
            borderRadius: '5px',
            cursor: 'pointer',
            color: 'black', 
            fontWeight: 'bold',
            fontSize: 'large',
            textAlign: 'center',
            WebkitPrintColorAdjust: 'exact',
            printColorAdjust: 'exact',
          }}
        >
          {!legend.min && legend.max && (
            <>
              <div>{`<`}</div>
              <div>{legend.max.toFixed(1)}</div>
            </>
          )}

          {legend.min && legend.max && (
            <>
              <div>{legend.min.toFixed(1)} /</div>
              <div>{legend.max.toFixed(1)} </div>
            </>
          )}

          {legend.min && !legend.max && (
            <>
              <div>{legend.min.toFixed(1)}</div>
              <div>{`>`}</div>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default MapLegend;
